<template>
  <div>
    <el-card @contextmenu.native="handlePaste($event)">
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>知识百科</el-breadcrumb-item>
            <el-breadcrumb-item>百科列表</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="6">
          <div>
            <el-aside>
              <el-input
                style="margin-bottom: 12px"
                size="small"
                placeholder="输入关键字进行过滤"
                v-model="filterText"
              ></el-input>
              <el-tree
                v-loading="loading"
                class="filter-tree"
                :data="data"
                :default-expanded-keys="defaultExpandKeys"
                :props="defaultProps"
                node-key="id"
                :filter-node-method="filterNode"
                @node-click="handleNodeClick"
                ref="tree"
              ></el-tree>
            </el-aside>
          </div>
        </el-col>
        <el-col :span="18">
          <div>
            <div
              :class="isShow == true ? 'show' : 'hidden'"
              style=" text-align:left"
            >
              <h1 style="font-size:20px;">{{ wiki.KnowledgeTitle }}</h1>
              <!--<div style="font-size:14px;">
                <span
                  :class="wiki.AddUserName ? '' : 'hidden'"
                  style="margin-right:20px;"
                  >发布人:{{ wiki.AddUserName }}</span
                >
                <span
                  :class="wiki.AddTime ? '' : 'hidden'"
                  style="margin-right:20px;"
                  >发布时间:{{ wiki.AddTime }}</span
                >
                <span
                  :class="wiki.EditUserNames ? '' : 'hidden'"
                  style="margin-right:20px;"
                  >编辑人:{{ wiki.EditUserNames }}</span
                >
                <span
                  :class="wiki.LastEditTime ? '' : 'hidden'"
                  style="margin-right:20px;"
                  >最近修改时间:{{ wiki.LastEditTime }}</span
                >
              </div>
               <div style="margin-top:10px;">
                      编辑人:{{wiki.EditUserNames}}
                      最近修改时间:{{wiki.LastEditTime}}|
              </div>-->
              <div
                style="margin-top:20px; "
                v-html="content"
                @dragstart.prevent
              >
                <!-- v-html 解析html标签，后面的赋值不需要添加{{}} -->
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {
  GetWikiNodeAndArticle,
  GetSingleKnowledge,
  GetKnowledgeContentDescry,
} from "../../until/ZeusApiSDK/Logic/WikiLogic";
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { ImageAddDomain } from "../../until/ZeusApiSDK/Logic/ImageStr";
export default {
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.getWikiNode();
  },
  methods: {
    handlePaste(event) {
      // 禁用鼠标右键
      event.preventDefault();
      return false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //获取树状结构列表
    getWikiNode: async function() {
      await GetWikiNodeAndArticle().then(res => {
        var resData = JSON.parse(res);
        var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
        this.currentRole = JSON.parse(Decrypt(currentUserRole));
        // if(this.currentRole.Key!='admin'&&this.currentRole.Key!='Manager'){//判断是否是管理员或者负责人
        //   const children = resData[0].children || [];
        //   const index = children.findIndex(d => d.id === 'c71c7ebf-4558-4955-8bb1-c055cfc4ae47');//获取公司制度节点索引
        //   const childrens = children[index].children || [];
        //   const indexs = childrens.findIndex(d => d.id === '9579843e-0c3f-42bc-b0ff-3f38edc2cbb2');//获取员工管理制度节点索引
        //   childrens.splice(indexs, 1);//删除节点
        // }
        this.data = resData;
        this.loading = false;
      });
    },
    //节点点击事件
    handleNodeClick(data) {
      if (
        data.children == "undefined" ||
        data.children == "" ||
        data.children == null
      ) {
        //获取文章详情
        GetSingleKnowledge(data.id).then((res) => {
          this.wiki = res;
          //获取文章内容并解密
          GetKnowledgeContentDescry(this.wiki.KnowledgeContent).then((res) => {
            //如返回的文本含有图片则为图片添加域名
            var data = ImageAddDomain(res, "http://e.ruizhiqi.com");
            this.content = data;
          });

          if (this.wiki != null) {
            this.isShow = true;
          }
        });
      }
    },
  },

  data() {
    return {
      wiki: {},
      content: "",
      filterText: "",
      isShow: false,
      loading: true,
      data: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      defaultExpandKeys: ["8f4e7c48-ea3d-4f28-ab28-e1b9340ef79f"],
    };
  },
};
</script>
<style lang="less" scoped>
.show {
  display: block;
}
.hidden {
  display: none;
}
</style>
